export const GOOGLE_MAPS_API_KEY = "AIzaSyBov1Wd7NcaoQmrLU5xnnEFQ2ZBiokzurk";
export const GOOGLE_MAPS_LIBRARIES = ['places', 'geometry','drawing'];